export default {
  name: 'wisk-chevron-down',
  width: 35,
  height: 35,
  paths: [{ d: 'M3.111,7.117a3.155,3.155,0,0,1,2.248.937L17.448,20.262,29.537,8.054a3.164,3.164,0,0,1,4.5,4.453L19.7,26.984a3.259,3.259,0,0,1-4.5,0L.863,12.507a3.164,3.164,0,0,1,2.248-5.39Z' }]
}
